/**
 * Oud of Kings — mobile menu drawer extras.
 * Adds the "best seller" label above the featured product and the bottom
 * row (brand + language switch) into Horizon's menu drawer. The markup is
 * rendered by Liquid in a <template id="lux-drawer-tpl"> in
 * layout/theme.liquid; this script only places it. Horizon can re-render
 * the header (section rendering / editor), so it re-applies on changes.
 */
(function () {
  'use strict';

  function apply() {
    var tpl = document.getElementById('lux-drawer-tpl');
    if (!tpl || !tpl.content) return;

    var drawers = document.querySelectorAll('.menu-drawer');
    for (var i = 0; i < drawers.length; i++) {
      var drawer = drawers[i];

      var featured = drawer.querySelector('.menu-drawer__featured-content');
      if (featured && !featured.querySelector('.lux-drawer__eyebrow')) {
        var eyebrow = tpl.content.querySelector('.lux-drawer__eyebrow');
        if (eyebrow) featured.insertBefore(eyebrow.cloneNode(true), featured.firstChild);
      }

      var hasFooter = false;
      for (var c = 0; c < drawer.children.length; c++) {
        if (drawer.children[c].classList.contains('lux-drawer__footer')) hasFooter = true;
      }
      if (!hasFooter) {
        var footer = tpl.content.querySelector('.lux-drawer__footer');
        if (footer) drawer.appendChild(footer.cloneNode(true));
      }
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      apply();
    });
  }

  function init() {
    apply();
    var root = document.getElementById('header-group') || document.body;
    if (typeof MutationObserver === 'function') {
      new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', schedule);
})();
